import { z } from 'zod';

/**
 * The user's static info (verified against the real IRD Enrollment form's
 * `name` / `address` / `mobile_number` fields — see docs/ird-site-analysis.md).
 * Stored once in IndexedDB (lib/db/profileRepo.ts), never on a server.
 */
export const UserProfileSchema = z.object({
  id: z.literal('local-profile'),
  name: z.string().min(2).max(120),
  mobileNumber: z.string().regex(/^[0-9]{7,15}$/, 'Mobile number must be 7-15 digits'),
  address: z.string().min(1),
  updatedAt: z.number(),
});
export type UserProfile = z.infer<typeof UserProfileSchema>;
